/**
 * Compute viewport-fixed coordinates for a portalled dropdown anchored to a trigger.
 * Uses getBoundingClientRect (no scrollY/scrollX) and flips above when needed.
 */
export const computeFixedDropdownPosition = (
  triggerEl,
  { maxHeight = 256, gap = 4 } = {}
) => {
  if (!triggerEl) return { top: 0, left: 0, width: 0, flipUp: false };

  const rect = triggerEl.getBoundingClientRect();
  const spaceBelow = window.innerHeight - rect.bottom - gap;
  const spaceAbove = rect.top - gap;
  const flipUp = spaceBelow < maxHeight && spaceAbove > spaceBelow;

  return {
    top: flipUp ? rect.top - gap : rect.bottom + gap,
    left: rect.left,
    width: rect.width,
    flipUp,
  };
};

/** Inline style props for a fixed portalled dropdown. */
export const fixedDropdownStyle = ({ top, left, width, flipUp }) => ({
  top,
  left,
  width,
  transform: flipUp ? "translateY(-100%)" : undefined,
});

/** Attach scroll/resize listeners; returns cleanup fn. Call once when dropdown opens. */
export const bindDropdownReposition = (triggerEl, onReposition, options) => {
  const reposition = () => {
    if (triggerEl) onReposition(computeFixedDropdownPosition(triggerEl, options));
  };
  reposition();
  window.addEventListener("scroll", reposition, true);
  window.addEventListener("resize", reposition);
  return () => {
    window.removeEventListener("scroll", reposition, true);
    window.removeEventListener("resize", reposition);
  };
};
